import React, { useState } from 'react';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Row, Col, Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';
// import ModalMessage from '../../components/widgets/modalMessage';
import SearchFormPayment from '../../components/widgets/formSearchPayment';
import DownloadButton from '../../components/widgets/downloadButton';
// import ModalFormPayment from '../../components/forms/payment/modal.form.payment';
const ModalFormPayment = React.lazy(() =>
  import('../../components/forms/payment/modal.form.payment'),
);

function PaymentReport() {
  const [infoReport, setInfoReport] = useState([]);
  const [currentFilter, setCurrentFilter] = useState({});
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: '',
  });

  const createFuelType = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    searching(currentFilter)
  };

  const editButton = (row) => {
    return (
      <Row>
        {/* {row.estado === 'PE' && */}
        <Col>
          <ModalFormPayment
            paymentSelect={row.id}
            title="Informacion de pago"
            button_text="Gestionar"
            button_variant="outline-primary"
            callback={createFuelType}
          />
        </Col>
        {/* } */}
      </Row>
    );
  };

  const searching = async (data) => {
    setCurrentFilter(data);
    const body = data;
    const respoReport = await get('/payment/', {}, body);
    if (respoReport.success) {
      setInfoReport(respoReport.data);
    } else {
      console.log(respoReport);
    }
  };

  return (
    <Base>
      {alert.show && (
        <Alert
          variant={alert.type}
          onClose={() => setAlert({ show: false })}
          dismissible
        >
          {alert.message}
        </Alert>
      )}
      <SearchFormPayment searching={searching} />
      <DownloadButton infoReport={infoReport} filename={'peritajes.csv'} separator={';'} />
      <ListTables
        data={infoReport}
        editar={editButton}
        messageWd="sin pagos en el filtro"
        headerAlwaysShow={true}
        hideFirst={true}
      />
    </Base>
  );
}

export default PaymentReport;
